import React, { useState, useEffect } from 'react';

const Clock: React.FC = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timerId = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timerId);
  }, []);

  return (
    <div className="text-center">
      <div className="text-7xl md:text-8xl font-mono font-bold text-gray-900 dark:text-white">
        {time.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true })}
      </div>
      <div className="text-xl md:text-2xl text-gray-500 dark:text-gray-light">
        {time.toLocaleDateString([], { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
      </div>
    </div>
  );
};

export default Clock;